export enum TransactionalCreditEvaluationStatus {
  CREATED = 'CREATED',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  APPLIED = 'APPLIED',
}
